<div class="modal-body">
  <h2 class="modal-title">Ändra åtgärdstyp för åtgärd: {{atgard.beteckning}}</h2>
  <div class="hr-div">
    <hr>
    </div>
    @if (messages.length > 0) {
      <div class="mx-2">
        <rask-message-panel [maxNumOfRows]="3" [items]="messages" [numberOfItemsToDisplay]="1">
        </rask-message-panel>
      </div>
    }

    <div class="pb-3">
      <rask-simple-selector
        class="w-100"
        label="Välj ny åtgärdstyp"
        [values]="atgardsTyper"
        [value]="atgard.atgardstyp"
        bindLabel="text"
        bindValue="value"
        (change)="typSelected($event)">
      </rask-simple-selector>
    </div>

    <div class="hr-div">
      <hr>
      </div>
      <div class="d-flex justify-content-end">
        <rask-button color="primary" (click)="save()" [disabled]="!canSave">Spara</rask-button>
        <rask-button color="secondary" (click)="close()">Avbryt</rask-button>
      </div>
    </div>
